export default __webpack_public_path__ + "locales/es/EmptyTrashDialog.json?hash=72242abde1220af58d027422634fb8cc";